/**
 * <s-favorite-toggle> — star button on a product card that adds/removes the
 * product from the visitor's favorites (stored in this browser).
 *
 * Attributes:
 *   data-handle       — product handle (required)
 *   data-label-add    — accessible label when not a favorite
 *   data-label-remove — accessible label when already a favorite
 *
 * Commands (via commandfor/command on the inner button):
 *   --toggle-favorite
 */
import { isFavorite, toggleFavorite, onFavoritesChange } from '@theme/favorites-store';

class SFavoriteToggle extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('command', (event) => {
      if (event.command !== '--toggle-favorite') return;
      toggleFavorite(this.dataset.handle);
    }, { signal: this.#ac.signal });
    onFavoritesChange(() => this.#sync(), this.#ac.signal);
    this.#sync();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #sync() {
    const button = this.querySelector('button');
    if (!button) return;
    const active = isFavorite(this.dataset.handle);
    button.setAttribute('aria-pressed', String(active));
    const label = active ? this.dataset.labelRemove : this.dataset.labelAdd;
    if (label) button.setAttribute('aria-label', label);
  }
}

if (!customElements.get('s-favorite-toggle')) customElements.define('s-favorite-toggle', SFavoriteToggle);
